export default "__VITE_ASSET__Zrf9TqJY__"